<template>
  <div class="collocation">
    <el-form
      label-position="right"
      :rules="rules"
      label-width="160px"
      ref="ruleForm"
      :model="datasArr"
    >
      <el-form-item v-show="status=='post'" label="优惠券类型" prop="coupontype">
        <el-select v-model="coupontype" @change="changetype" placeholder="请选择">
          <el-option
            v-for="item in coupontypeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="药品供应商" prop="drug_provider_ids" v-if="coupontype == 'drug_reduce' || coupontype == 'drug_discount'">
        <el-select v-model="drug_provider_ids" placeholder="请选择">
          <el-option
            v-for="(child, index) in providers"
            :key="index"
            :label="getproviderName(child)"
            :value="child.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="coupontype=='consultation'"
        label="选择医生"
        prop="doctor_type_id"
        :required="isconsultation"
      >
        <div class="tree-content">
          <div class="left">
            <el-tree
            :data="doctors"
            show-checkbox
            node-key="id"
            ref="leftTreeDoctors"
            :props="defaultLeftProps"
            :default-expanded-keys="doctor_expanded_keys"
            @check-change="handleLeftTreeCheckChange"
            ></el-tree>
          </div>
          <div class="mid">
            <div class="to-right" @click="doctorsToRight()">
              <img v-show="left_doctors.length == 0" src="../../../assets/img/right.png" alt="" />
              <img v-show="left_doctors.length > 0" src="../../../assets/img/right_checked.png" alt="" />
            </div>
            <div class="to-left" @click="doctorsToLeft()">
              <img v-show="right_doctors.length == 0" src="../../../assets/img/left.png" alt="" />
              <img v-show="right_doctors.length > 0" src="../../../assets/img/left_checked.png" alt="" />
            </div>
          </div>
          <div class="right">
            <el-tree
            :data="select_doctors"
            show-checkbox
            node-key="id"
            ref="rightTreeDoctors"
            :props="defaultRightProps"
            @check-change="handleRightTreeCheckChange"
            ></el-tree>
          </div>
        </div>
        <!-- <el-input v-model="datasArr.doctor_type_id"></el-input> -->
      </el-form-item>
      <el-form-item
        v-show="coupontype=='coupon_vip'"
        label="会员类型编号"
        prop="vip_type_id"
        :required="iscoupon_vip"
      >
        <el-input v-model="datasArr.vip_type_id"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="datasArr.title"></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="cover">
        <el-upload
          class="avatar-uploader"
          action
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="cover" :src="cover" class="avatar" alt="加载失败"/>
          <em v-show="!cover && !uploading" class="el-icon-plus avatar-uploader-icon"></em>
          <em class="el-icon-loading avatar-uploader-icon" v-show="uploading"></em>
        </el-upload>
      </el-form-item>
      <el-form-item label="描述" prop="content">
        <el-input v-model="datasArr.content"></el-input>
      </el-form-item>
      <el-form-item label="时间范围" prop="defaulttime">
        <el-date-picker
          v-model="defaulttime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        v-show="coupontype=='drug_discount'||coupontype=='consultation'||coupontype=='coupon_vip'"
        label="折扣值"
        prop="discount"
      >
        <el-input v-model="datasArr.discount"></el-input>
      </el-form-item>
      <el-form-item
        v-show="coupontype=='drug_reduce'"
        label="满减值(满足条件金额)"
        prop="amount"
        :required="isdrug_reduce"
      >
        <el-input v-model="datasArr.amount"></el-input>
      </el-form-item>
      <el-form-item
        v-show="coupontype=='drug_reduce'"
        label="满减值(优惠金额)"
        prop="reduce_amount"
        :required="isdrug_reduce"
      >
        <el-input v-model="datasArr.reduce_amount"></el-input>
      </el-form-item>
      <el-form-item label="优惠券数量" prop="count">
        <el-input v-model="datasArr.count"></el-input>
      </el-form-item>
      <el-form-item label="每人可领数量" prop="receive_count">
        <el-input v-model="datasArr.receive_count"></el-input>
      </el-form-item>
    </el-form>
    <el-button class="conbutton" type="primary" @click="pushdata('ruleForm')">提交</el-button>
  </div>
</template>
<script>
// import lrz from "lrz";
// import md5 from "js-md5";
import {_} from 'vue-underscore';
import http from '../../../api/pontusApiConfig'
import http2 from '../../../api/uploadApiConfig'
import http3 from '../../../api/dorisApiConfig'
import http4 from '../../../api/iapetusApiConfig'
export default {
  data() {
    return {
      datasArr: {},
      loading: true,
      status: "post",
      uploading: false,
      rules: {
        doctor_type_id: [{ message: "请填写医生分类", trigger: "blur" }],
        vip_type_id: [{ message: "请填写会员类型编号", trigger: "blur" }],
        title: [
          { required: true, message: "请填写优惠券标题", trigger: "blur" }
        ],
        cover: [
          { required: false, message: "请添加优惠券封面", trigger: "blur" }
        ],
        content: [{ required: true, message: "请填写描述", trigger: "blur" }],
        receive_count: [
          { required: true, message: "请填写每人可领数量", trigger: "blur" }
        ],
        count: [
          { required: true, message: "请填写优惠券数量", trigger: "blur" }
        ]
      },
      defaulttime: ["", ""],
      cover: "",
      imageUrl: "http://coupons.jpg",
      coupontype: "drug_discount",
      coupontypeArr: [
        {
          value: "drug_discount",
          label: "药品折扣"
        },
        {
          value: "drug_reduce",
          label: "药品满减"
        },
        {
          value: "consultation",
          label: "问诊券"
        },
        {
          value: "coupon_vip",
          label: "vip优惠券"
        }
      ],
      isdrug_discount: true,
      isdrug_reduce: false,
      isconsultation: false,
      iscoupon_vip: false,
      providers:[],
      drug_provider_ids: 2,
      defaultLeftProps: {
          children: "doctors",
          label: "name"
      },
      defaultRightProps: {
          label: "name"
      },
      doctor_expanded_keys: [],
      all_doctors: [],
      doctors: [],
      select_doctors: [],
      left_doctors: [],
      right_doctors: []
    };
  },
  props: ["putData"],
  created() {
    // console.log(this.putData)
    this.updata(this.putData)
    this.getProviderDate()
  },
  methods: {
    handleLeftTreeCheckChange(){
      let that = this;
      that.left_doctors = _.filter(that.$refs.leftTreeDoctors.getCheckedKeys(), function(i){ return i !== undefined; });
    },
    handleRightTreeCheckChange(){
      let that = this;
      that.right_doctors = _.filter(that.$refs.rightTreeDoctors.getCheckedKeys(), function(i){ return i !== undefined; });
      
    },
    doctorsToRight(){
      let that = this;
      if(that.left_doctors.length > 0){
        _.map(that.select_doctors, function(item, index){
          console.log(index)
          that.left_doctors.push(item['id'])
        });
        that.doctor_expanded_keys = [];
        that.select_doctors = [];
        that.doctors = [];
        let all_doctors = that.all_doctors;
        for(let i = 0; i < all_doctors.length; i++){
          let filter_doctors = _.filter(all_doctors[i]['doctors'], function(i){ return that.left_doctors.indexOf(i.id) > -1; });
          if(filter_doctors.length > 0){
            that.select_doctors = that.select_doctors.concat(filter_doctors);
            if(all_doctors[i]['doctors'].length > filter_doctors.length){
              that.doctor_expanded_keys.push(all_doctors[i]['studio_id'])
            }
          }
          let obj = {
            id: all_doctors[i]['id'],
            name: all_doctors[i]['name'],
            doctors: _.filter(all_doctors[i]['doctors'], function(i){ return that.left_doctors.indexOf(i.id) < 0; })
          }
          that.doctors.push(obj)
        }
        that.left_doctors = []
      }
    },
    doctorsToLeft(){
      let that = this;
      if(that.right_doctors.length > 0){
        let left_doctors = []
        _.map(that.select_doctors, function(item, index){
          console.log(index)
          if(that.right_doctors.indexOf(item['id']) < 0){
            left_doctors.push(item['id'])
          }
        });
        
        that.select_doctors = [];
        that.doctors = [];
        let all_doctors = that.all_doctors;
        for(let i = 0; i < all_doctors.length; i++){
          let filter_doctors = _.filter(all_doctors[i]['doctors'], function(i){ return left_doctors.indexOf(i.id) > -1; });
          if(filter_doctors.length > 0){
            that.select_doctors = that.select_doctors.concat(filter_doctors);
            if(all_doctors[i]['doctors'].length > filter_doctors.length){
              that.doctor_expanded_keys.push(all_doctors[i]['studio_id'])
            }
          }
          let obj = {
            id: all_doctors[i]['id'],
            name: all_doctors[i]['name'],
            doctors: _.filter(all_doctors[i]['doctors'], function(i){ return left_doctors.indexOf(i.id) < 0; })
          }
          that.doctors.push(obj)
        }
        that.right_doctors = []
      }
    },
    updata(val){
      let that = this;
      that.status = val[0];
      that.datasArr = val[1];
      that.coupontype = val[2];
      if (this.status == "put") {
        that.defaulttime = [
          new Date(that.datasArr.start_time * 1000),
          new Date(that.datasArr.end_time * 1000)
        ];
        that.cover = val[1].cover;
      } else {
        that.defaulttime = [new Date(), new Date()];
        that.cover = "";
      }
      if(that.coupontype=='consultation'){
        http4.get("/admin/studios/doctors").then(function(res) {
          that.all_doctors = res.data.data;
          that.doctors = res.data.data;
          that.select_doctors = [];
          if(that.datasArr.doctor_ids){
            that.doctors = [];
            that.left_doctors = that.datasArr.doctor_ids.split(',');
            that.left_doctors = _.map(that.left_doctors, function(item, index){
                console.log(index)
                item = parseInt(item)
                return item;
            });
            let all_doctors = that.all_doctors;
            for(let i = 0; i < all_doctors.length; i++){
              let filter_doctors = _.filter(all_doctors[i]['doctors'], function(i){ return that.left_doctors.indexOf(i.id) > -1; });
              if(filter_doctors.length > 0){
                that.select_doctors = that.select_doctors.concat(filter_doctors);
              }
              let obj = {
                id: all_doctors[i]['id'],
                name: all_doctors[i]['name'],
                doctors: _.filter(all_doctors[i]['doctors'], function(i){ return that.left_doctors.indexOf(i.id) < 0; })
              }
              that.doctors.push(obj)
            }
            that.left_doctors = []
          }
        });
      }
    },
    getProviderDate(){
      let that = this;
      let params = {
          page: 1,
          page_size: 100
      }
      http3.get("/admin/providers",{params: params}).then(function(res) {
          // that.changeArr.push(res.data.data.providers)
          // console.log(res.data.data)
          that.providers = res.data.data.providers
      });
    },
    getproviderName(item){
      if(item['type'] == 1){
        return item['name'] + "(颗粒)";
      }else{
        return item['name'] + "(饮片)";
      }
    },
    changetype(val) {
      switch (val) {
        case "drug_discount":
          this.isdrug_discount = true;
          this.isdrug_reduce = false;
          this.isconsultation = false;
          this.iscoupon_vip = false;
          break;
        case "drug_reduce":
          this.isdrug_discount = false;
          this.isdrug_reduce = true;
          this.isconsultation = false;
          this.iscoupon_vip = false;
          break;
        case "consultation":
          this.isdrug_discount = false;
          this.isdrug_reduce = false;
          this.isconsultation = true;
          this.iscoupon_vip = false;
          break;
        case "coupon_vip":
          this.isdrug_discount = false;
          this.isdrug_reduce = false;
          this.isconsultation = false;
          this.iscoupon_vip = true;
          break;
      }
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", "common/coupon");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("/upload", ossData).then(function(res) {
            if (res.data.status_code == 200) {
                that.imageUrl = "common/coupon" + filename;
                that.cover = URL.createObjectURL(file);
            }
            that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    pushdata(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid);
        if (valid) {
          if (this.status == "put") {
            this.put_data();
          } else {
            this.post_data();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    put_data() {
      // console.log(this.datasArr);
      let that = this;
      console.log(this.datasArr)
      let params = {
        coupon_id: this.datasArr.id,
        coupon_type: this.coupontype,
        title: this.datasArr.title,
        cover: this.imageUrl,
        content: this.datasArr.content,
        start_time: parseInt(this.defaulttime[0].getTime() / 1000),
        end_time: parseInt(this.defaulttime[1].getTime() / 1000),
        count: this.datasArr.count,
        receive_count: this.datasArr.receive_count || ""
      };
      let ids = []
      _.map(that.select_doctors, function(item, index){
        console.log(index)
        ids.push(item['id'])
      });
      switch (this.coupontype) {
        case "drug_discount":
          params["drug_provider_ids"] = this.drug_provider_ids;
          params["discount"] = this.datasArr.discount;
          break;
        case "drug_reduce":
          params["drug_provider_ids"] = this.drug_provider_ids;
          params["amount"] = this.datasArr.amount;
          params["reduce_amount"] = this.datasArr.reduce_amount;
          break;
        case "consultation":
          params["discount"] = this.datasArr.discount;
          params["doctor_ids"] = ids.join(',');
          break;
        case "coupon_vip":
          params["discount"] = this.datasArr.discount;
          params["vip_type_id"] = this.datasArr.vip_type_id;
          break;
      }

      // console.log(params);
      http.put("admin/coupon", params).then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.$emit("putsuccess", 1);
        }
      });
    },
    post_data() {
      // amount
      // reduce_amount
      // doctor_type_id
      // vip_type_id
      // console.log(this.datasArr);
      let that = this;
      let params = {
        coupon_type: this.coupontype,
        title: this.datasArr.title,
        cover: this.imageUrl,
        content: this.datasArr.content,
        start_time: parseInt(this.defaulttime[0].getTime() / 1000),
        end_time: parseInt(this.defaulttime[1].getTime() / 1000),
        count: this.datasArr.count,
        receive_count: this.datasArr.receive_count || "",
        discount: this.datasArr.discount
      };
      let ids = []
      _.map(that.select_doctors, function(item, index){
        ids.push(item['id'])
      });
      // console.log(params);
      switch (this.coupontype) {
        case "drug_discount":
          params["drug_provider_ids"] = this.drug_provider_ids;
          params["discount"] = this.datasArr.discount;
          break;
        case "drug_reduce":
          params["drug_provider_ids"] = this.drug_provider_ids;
          params["amount"] = this.datasArr.amount;
          params["reduce_amount"] = this.datasArr.reduce_amount;
          break;
        case "consultation":
          params["discount"] = this.datasArr.discount;
          params["doctor_ids"] = ids.join(',');
          break;
        case "coupon_vip":
          params["discount"] = this.datasArr.discount;
          params["vip_type_id"] = this.datasArr.vip_type_id;
          break;
      }
      // console.log(params);
      http.post("admin/coupon", params).then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.$emit("putsuccess", 1);
        }
      });
    }
  },
  watch: {
    putData(val) {
      this.updata(val)
      // console.log(val);
      // this.status = val[0];
      // console.log(this.status)
      // console.log(val[0])
      // this.datasArr = val[1];
      // this.coupontype = val[2];
      // // this.providers = val[3];
      // if (this.status == "put") {
      //   console.log(1111)
      //   this.defaulttime = [
      //     new Date(this.datasArr.start_time * 1000),
      //     new Date(this.datasArr.end_time * 1000)
      //   ];
      //   // console.log(this.defaulttime);
      //   this.cover = val[1].cover;
      // } else {
      //   console.log(2222)
      //   this.defaulttime = [new Date(), new Date()];
      //   this.cover = "";
      // }
      // console.log(this.cover)
    }
  }
};
</script>
<style scoped>

.conbutton {
  display: block;
  margin: 0 auto;
}
.fc {
  color: #606266;
}
.tree-content{
  width: 100%;
  box-sizing: border-box;
  display: flex;
}
.tree-content .left,
.tree-content .right{
  height: 200px;
  padding: 5px;
  width: 45%;
  box-sizing: border-box;
  border: 1px solid #cccccc;
  overflow-y: auto;
}
.tree-content .mid{
  width: 10%;
  box-sizing: border-box;
  position: relative;
}
.tree-content .mid .to-right,
.tree-content .mid .to-left{
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
}
.tree-content .mid .to-right img,
.tree-content .mid .to-left img{
  width: 100%;
}
.tree-content .mid .to-right{
  top: 35px;
}
.tree-content .mid .to-left{
  bottom: 35px;
}
</style>